var exports = {
  "W": "VoiceP2pConsentModal.module__points___WGUwZ0",
  "m": "VoiceP2pConsentModal.module__checkboxLabel___WGUwZ0",
};

module.exports = exports;
